// ** Angular Imports
import { Pipe, PipeTransform } from '@angular/core';

// ** Costants Import
import { environment } from 'src/environments/environment';


@Pipe({ name: 'cdnUrl' })
export class CdnUrlPipe implements PipeTransform {
  transform(imageName: string, folder = 'home'): string {
    return `${environment.cdnBaseUrl}${folder}/${imageName}`;
  }
}